/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Compensation_PlaceholderInputs */

const en_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Frames`)
};

const fr_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'images`)
};

const de_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Frames`)
};

const it_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di fotogrammi`)
};

const ru_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество кадров`)
};

const es_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de fotogramas`)
};

const zh_cn2_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧数`)
};

const ja_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム数`)
};

const hi_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रेमों की संख्या`)
};

const pt_pt2_timing_sync_compensation_placeholder = /** @type {(inputs: Timing_Sync_Compensation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de quadros`)
};

/**
* | output |
* | --- |
* | "Number of Frames" |
*
* @param {Timing_Sync_Compensation_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_compensation_placeholder = /** @type {((inputs?: Timing_Sync_Compensation_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Compensation_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_compensation_placeholder(inputs)
	if (locale === "de") return de_timing_sync_compensation_placeholder(inputs)
	if (locale === "it") return it_timing_sync_compensation_placeholder(inputs)
	if (locale === "ru") return ru_timing_sync_compensation_placeholder(inputs)
	if (locale === "es") return es_timing_sync_compensation_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_compensation_placeholder(inputs)
	if (locale === "ja") return ja_timing_sync_compensation_placeholder(inputs)
	if (locale === "hi") return hi_timing_sync_compensation_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_compensation_placeholder(inputs)
	return en_timing_sync_compensation_placeholder(inputs)
});